export type StartDestination = 'welcome' | 'summary' | 'first-open-step';

export type NextDestination = 'summary' | 'first-open-step';
